import * as actions from "../actions";

const initialState = {
  username: "",
  isImpersonating: false,
  calculatedPermissions: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //USER ACTIONS
    case actions.UPDATE_USER:
      action.payload.user.calculatedPermissions = {};
      action.payload.user.permissionList.forEach((permission) => {
        action.payload.user.calculatedPermissions[permission] = true;
      });
      return { ...state, ...action.payload.user };
    case actions.UPDATE_USER_CUSTOM_DATA:
      return { ...state, custom_data: action.payload };
    default:
      return state;
  }
};

export default reducer;
